import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';

import { DocumentsPartialState } from './documents.reducer';
import { Document, DocumentForm } from './documents.models';
import {
  LoadOwnerDocuments,
  LoadOwnerDocumentsSuccess,
  LoadOwnerDocumentsFail,
  DocumentsActionTypes,
  SaveDocumentInformation,
  UpdateDocumentInformation,
  SaveUpload,
  SaveUploadFail,
  UpdateUpload,
  UpdateUploadFail,
  SaveUploadSuccess,
  UpdateUploadSuccess
} from './documents.actions';
import { map } from 'rxjs/operators';
import { DocumentsService } from '../documents.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentsEffects {
  @Effect()
  getOwnerDocuments$ = this.dataPersistence.fetch(
    DocumentsActionTypes.LOAD_OWNER_DOCUMENTS,
    {
      run: (action: LoadOwnerDocuments, state: DocumentsPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .getDocumentsByOwner(action.payload)
          .pipe(
            map(
              (documents: Document[]) =>
                new LoadOwnerDocumentsSuccess(documents)
            )
          );
      },

      onError: (action: LoadOwnerDocuments, error) => {
        
        return new LoadOwnerDocumentsFail(error);
      }
    }
  );

  @Effect()
  saveDocument$ = this.dataPersistence.fetch(
    DocumentsActionTypes.SAVE_DOCUMENT_INFORMATION,
    {
      run: (action: SaveDocumentInformation, state: DocumentsPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .saveDocumentInformation(action.payload)
          .pipe(map((document: DocumentForm) => new SaveUpload(document)));
      },

      onError: (action: SaveDocumentInformation, error) => {
        
        return new SaveUploadFail(error);
      }
    }
  );

  @Effect()
  updateDocument$ = this.dataPersistence.fetch(
    DocumentsActionTypes.UPDATE_DOCUMENT_INFORMATION,
    {
      run: (
        action: UpdateDocumentInformation,
        state: DocumentsPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .updateDocumentInformation(action.payload)
          .pipe(map((document: DocumentForm) => new UpdateUpload(document)));
      },

      onError: (action: UpdateDocumentInformation, error) => {
        
        return new UpdateUploadFail(error);
      }
    }
  );

  @Effect()
  upload$ = this.dataPersistence.fetch(DocumentsActionTypes.SAVE_UPLOAD, {
    run: (action: SaveUpload, state: DocumentsPartialState) => {
      // Your custom REST 'load' logic goes here. For now just return an empty list...
      return this.service
        .upload(action.payload)
        .pipe(map((document: Document) => new SaveUploadSuccess(document)));
    },

    onError: (action: SaveUpload, error) => {
      
      return new SaveUploadFail(error);
    }
  });

  @Effect()
  editUpload$ = this.dataPersistence.fetch(DocumentsActionTypes.UPDATE_UPLOAD, {
    run: (action: UpdateUpload, state: DocumentsPartialState) => {
      // Your custom REST 'load' logic goes here. For now just return an empty list...
      return this.service
        .upload(action.payload)
        .pipe(map((document: Document) => new UpdateUploadSuccess(document)));
    },

    onError: (action: UpdateUpload, error) => {
      
      return new UpdateUploadFail(error);
    }
  });

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<DocumentsPartialState>,
    private service: DocumentsService
  ) {}
}
